import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, Ref, inject } from "vue"
import { usePasswordValidation } from "@/hooks/usePasswordValidation"
import { AHEAD_THEME, ProductTypeEnum } from "@/constants"


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordForm',
  props: {
  submitBtnLabel: {
    type: String,
    default: "Create Password",
  },
  isSubmitting: {
    type: Boolean,
    default: false,
  },
},
  emits: ["submit", "gotoPrev", "input"],
  setup(__props, { emit }) {



const productType = inject("productType", {}) as Ref<ProductTypeEnum>

const isAheadClient = computed(() => productType.value === ProductTypeEnum.Ahead)

const theme = computed(() => {
  return isAheadClient.value ? AHEAD_THEME : undefined
})

const passwordForm = ref({
  password: "",
  confirmPassword: "",
})



const observer = ref(null)

const { strengthFeedback, passwordStrengthColor } = usePasswordValidation(
  computed(() => passwordForm.value.password)
)

const onSubmit = async () => {
  const validity = await (observer.value as any)?.validateWithInfo()

  if (!validity.isValid) return

  emit("input", passwordForm.value.password)
  emit("submit", passwordForm.value.password)
}

return { __sfc: true,productType, isAheadClient, theme, passwordForm, emit, observer, strengthFeedback, passwordStrengthColor, onSubmit }
}

})